<template>
<div>
<div class="text-center mt-4 pt-3"><img src="/images/supalytic-icon.svg" width="50"></div>
<div class="homepage_heading pt-4 mt-3 pb-4 px-3">Benefits of using Supalytic</div>

<div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>
<div v-else-if="items.length == 0" class="text-center py-2">No data</div>

<div v-else class="row">
  <div class="col-md-12">
    <div class="row pt-4">
      <div v-for="(item, index) in items" :key="index.id" class="col-md-3 col-12 px-3 p-0 px-md-2 mb-3 d-flex align-items-stretch">
        <div class="card home w-100">
          <div class="card-body h-100 text-center">
              <i :class="`${item.icon} fa-2x`"></i>
            <div class="mt-2" style="font-size:1rem;font-weight:bold;">{{ item.name }}</div>
            <div class="mt-2" style="font-size:0.9rem;">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>    
  </div>
</div>
</div>
</template>

<script>
export default {

  data() {
    return {
      loading: true,
      items: [],
    };
  },

  created() {
    this.getData();
  },

  methods: {

    getData() {

      axios.get('/get/benefits').
      then((response) => {
        this.items = response.data;
        this.loading = false;
      });

    },
  },
};
</script>